/**
 * HTML del bloque de retroalimentación en modales SweetAlert (quiz).
 * Colores por zona: Scenario2 naranja, 3 violeta, 4 azul, 5 verde.
 */

const THEME_MODIFIER_CLASS = {
	orange: "quiz-feedback-block--orange",
	violet: "quiz-feedback-block--violet",
	blue: "quiz-feedback-block--blue",
	green: "quiz-feedback-block--green",
};

function escapeHtml(str) {
	return String(str ?? "")
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");
}

/** Tras escapar todo, reintroduce solo etiquetas inline muy acotadas (p. ej. <i> en textos fijos del repo). */
function restoreAllowedInlineTags(escaped) {
	return escaped
		.replace(/&lt;i&gt;/gi, "<i>")
		.replace(/&lt;\/i&gt;/gi, "</i>")
		.replace(/&lt;em&gt;/gi, "<em>")
		.replace(/&lt;\/em&gt;/gi, "</em>")
		.replace(/&lt;b&gt;/gi, "<b>")
		.replace(/&lt;\/b&gt;/gi, "</b>")
		.replace(/&lt;strong&gt;/gi, "<strong>")
		.replace(/&lt;\/strong&gt;/gi, "</strong>");
}

/**
 * @param {string} retroalimentacion - texto; admite <i>, <em>, <b>, <strong> (sin atributos) para cursiva/negrita
 * @param {"orange"|"violet"|"blue"|"green"} theme
 * @returns {string} fragmento HTML seguro para interpolar en textHtml
 */
export function buildQuizFeedbackBlockHtml(retroalimentacion, theme = "orange") {
	const modifier = THEME_MODIFIER_CLASS[theme] || THEME_MODIFIER_CLASS.orange;
	const bodyHtml = restoreAllowedInlineTags(escapeHtml(retroalimentacion)).replace(/\n/g, "<br/>");
	return `
    <div class="quiz-feedback-block ${modifier} txt22">
      <div class="quiz-feedback-block__inner">
        <div class="quiz-feedback-block__accent" aria-hidden="true"></div>
        <div class="quiz-feedback-block__body">
          <div class="quiz-feedback-block__label">Retroalimentación:</div>
          <div class="quiz-feedback-block__text">${bodyHtml}</div>
        </div>
      </div>
    </div>`;
}
